import { render, staticRenderFns } from "./YouAndMeTextSettings.vue?vue&type=template&id=2fb0af50&scoped=true&"
import script from "./YouAndMeTextSettings.vue?vue&type=script&lang=js&"
export * from "./YouAndMeTextSettings.vue?vue&type=script&lang=js&"
import style0 from "./YouAndMeTextSettings.vue?vue&type=style&index=0&id=2fb0af50&lang=scss&scoped=true&"
import style1 from "./YouAndMeTextSettings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0af50",
  null
  
)

export default component.exports